module.exports = __webpack_public_path__ + "static/media/world-quant-logo.53fb1ee8.png";